// Silent image compression - converts large images to optimized JPEGs before upload
// No loaders/progress shown to admin - happens automatically in background

export const compressImage = (file, maxWidthPx = 1280, qualityVal = 0.75) => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) { resolve(file); return; }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let { width, height } = img;
        if (width > maxWidthPx) {
          height = Math.round((height * maxWidthPx) / width);
          width = maxWidthPx;
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (!blob) { resolve(file); return; }
            const compressed = new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), {
              type: 'image/jpeg', lastModified: Date.now()
            });
            resolve(compressed);
          },
          'image/jpeg',
          qualityVal
        );
      };
      img.onerror = () => resolve(file);
    };
    reader.onerror = () => resolve(file);
  });
};

// Compress every image regardless of size - always converts to optimized JPEG
export const compressMultiple = async (files) => {
  const results = [];
  for (const file of files) {
    try {
      const compressed = await compressImage(file);
      results.push(compressed);
    } catch {
      results.push(file);
    }
  }
  return results;
};
